<template>
  <a-modal
    title="配置"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
  >
    <a-form :form="form">

      <div v-if="hiddenSign == '0'">
        <label>配置型号</label>
        <a-tree
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          @select="onSelect"
          v-model="selectedKeys"
          :treeData="modelData"
        />
        <a-row>
          <a-col :span="24" style="display: flex;justify-content: center;">
            <a-button type="primary"  @click="handleSubmit(1)" html-type="submit" style="margin-right: 10px">关联</a-button>
            <a-button type="primary" @click="handleSubmit(2)" html-type="submit">排除</a-button>
          </a-col>
        </a-row>
      </div>

      <div v-if="hiddenSign == '1'">
        <label>配置订单类型</label>
        <a-tree
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          v-model="selectedOrderType"
          :treeData="orderTypeData"
        />

        <a-row>
          <a-col :span="24" style="display: flex;justify-content: center;">
            <a-button type="primary" v-if="relaType == '1' || relaType == '0'" @click="handleSubmit(1)" html-type="submit" style="margin-right: 10px">关联</a-button>
            <a-button type="primary" v-if="relaType == '2' || relaType == '0'" @click="handleSubmit(2)" html-type="submit">排除</a-button>
          </a-col>
        </a-row>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { configModel2 } from '@/api/enterprise/model'
// import { configModel2 } from '@/api/enterprise/enterprise'

import { getDemandRelated, configModels, configOrderTypes } from '@/api/enterprise/guarantee'
import { getOrderTypeTree } from '@/api/basicdatas/OrderType'

export default {
  name: 'EnterpriseDetailsModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      modelData: [],
      visible: false,
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      relaType: '',
      hiddenSign: '',
      demandId: '',
      selectedOrderType: [],
      orderTypeData: []
    }
  },
  watch: {
    checkedKeys (val) {
      console.log('onCheck', val)
    }
  },
  methods: {
    onExpand (expandedKeys) {
      console.log('onExpand', expandedKeys)
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    },
    onSelect (selectedKeys, info) {
      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },
    config (parentId) {
      this.form.resetFields()
      this.visible = true
      this.hiddenSign = '0'
      this.demandId = parentId

      getDemandRelated(parentId).then(res => {
        if (res.code === 0) {
          this.demandData = res.data
          this.relaType = this.demandData.relaType

          configModel2({ 'enterpriseId': this.demandData.enterpriseId }).then(res => {
            if (res.code === 0) {
              this.modelData = res.data
              this.selectedKeys = this.demandData.relaModelIds
            }
          })

          getOrderTypeTree({ 'enterpriseId': this.demandData.enterpriseId }).then(res => {
            if (res.code === 0) {
              this.orderTypeData = res.data
              this.selectedOrderType = this.demandData.relaOrderTypes
            }
          })
        }
      })
    },
    edit (record) {
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'enterprisePriceId', 'enterpriseId', 'installationType', 'priceType', 'price', 'application', 'proportion', 'priceRemark', 'status', 'delStatus', 'createUser', 'createTime', 'updateUser', 'updateTime'))
      })
    },
    handleSubmit (relaType) {
      console.log(this.selectedKeys)
      if (this.hiddenSign === '1') {
        let orderTypeData = {}
        orderTypeData.demandId = this.demandId
        orderTypeData.relaType = relaType
        orderTypeData.relaOrderTypes = this.selectedOrderType
        configOrderTypes(orderTypeData).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
          }
        })
        this.visible = false
      } else {
        let modelData = {}
        modelData.demandId = this.demandId
        modelData.relaType = relaType
        modelData.relaModelIds = this.selectedKeys
        configModels(modelData).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
          }
        })
      }
      this.hiddenSign = '1'
    }
  }
// watch: {
//   /*
//     'selectedRows': function (selectedRows) {
//       this.needTotalList = this.needTotalList.map(item => {
//         return {
//           ...item,
//           total: selectedRows.reduce( (sum, val) => {
//             return sum + val[item.dataIndex]
//           }, 0)
//         }
//       })
//     }
//     */
// }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>